var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuetzalDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "quetzal-default",
    d: "M4,29A25,25,0,1,1,29,54,25.02,25.02,0,0,1,4,29Zm4.167,0A20.833,20.833,0,1,0,29,8.167,20.868,20.868,0,0,0,8.167,29Zm31.25,6.25a8.3,8.3,0,0,1-.521,2.792l1.979,1.979a2.077,2.077,0,0,1-2.937,2.938L36.5,41.521a8.2,8.2,0,0,1-5.417,2.063H26.937A8.344,8.344,0,0,1,18.6,35.25V22.771a8.344,8.344,0,0,1,8.333-8.333h4.146a8.344,8.344,0,0,1,8.333,8.333Zm-12.5,4.167h4.146a4.083,4.083,0,0,0,2.479-.833l-1.5-1.5a2.077,2.077,0,1,1,2.938-2.937l.25.25V22.771A4.179,4.179,0,0,0,31.062,18.6H26.917a4.179,4.179,0,0,0-4.167,4.167V35.25A4.179,4.179,0,0,0,26.917,39.417Z",
    transform: "translate(-4 -4)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuetzalDefault);
export default __webpack_public_path__ + "static/media/quetzal-default.0b2b547c0ffd76586d6b13553cd8724f.svg";
export { ForwardRef as ReactComponent };